export enum BaseConst {
    TOKEN_ID = "APS-TOKEN"
}